import { mergeSxProps, RadioIndicator, Text } from "@clipboard-health/ui-components";
import { Stack, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { SelectableBox } from "@src/appV2/redesign/components/SelectableBox";

import { type ExternalAccount } from "../api/schema";
import { ExternalAccountLogo } from "./ExternalAccountLogo";

export interface ExternalAccountItemProps {
  externalAccount: ExternalAccount;
  disabled: boolean;
  selected: boolean;
  onSelect: (stripeId: string) => void;
  sx?: SxProps<Theme>;
}

export function ExternalAccountItem(props: ExternalAccountItemProps) {
  const { externalAccount, disabled, selected, onSelect, sx } = props;

  return (
    <SelectableBox
      data-testid={`external-account-item-${externalAccount.stripeId}`}
      variant="secondary"
      sx={mergeSxProps(
        (theme) => ({
          backgroundColor: disabled
            ? theme.palette.background.quaternary
            : theme.palette.background.tertiary,
          borderColor: theme.palette.border?.primary,
          overflow: "hidden",
          px: theme.spacing(5),
          "&.Mui-disabled": {
            borderColor: theme.palette.border?.primary,
          },
        }),
        sx
      )}
      isSelected={selected}
      disabled={disabled}
      onToggleSelect={(didSelect) => {
        if (didSelect && !selected) {
          onSelect(externalAccount.stripeId);
        }
      }}
    >
      <Stack
        sx={() => ({
          flexDirection: "row",
          alignItems: "center",
        })}
      >
        <ExternalAccountLogo
          externalAccount={externalAccount}
          sx={(theme) => ({ marginRight: theme.spacing(1) })}
          grayscale={disabled}
        />
        <Text
          variant="body2"
          sx={(theme) => ({
            flex: 1,
            textAlign: "left",
            marginRight: theme.spacing(5),
            color: disabled ? theme.palette.text.tertiary : theme.palette.text.primary,
          })}
        >
          {externalAccount.providerName} ···· {externalAccount.last4}
        </Text>
        <RadioIndicator selected={selected} />
      </Stack>
    </SelectableBox>
  );
}
